
class AjaxApi{
    static ajaxurl: string = (window as any).boxReact?.ajaxurl || 'https://custom.boxlocal/wp-admin/admin-ajax.php';

    static async query(action: string, data: any = {}){
        data.action = action;

        return fetch(this.ajaxurl, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams(data),
        })
            .then(response => response.json())
    }


    static async askWizardPrice(choices: any, productId: any){
        return this.query('ask-wizard-price', {productId:productId, choices: JSON.stringify(choices)});
    }
    static async addToCart(choices: any, productId: any){
        return this.query('add-cart', {productId:productId, choices: JSON.stringify(choices)});
    }

}

export default AjaxApi;
